import Axios from '../common/http.js';

/**
 * 用户账号列表
 */
export const accountList = (data) => {
	return Axios.get('/gorc/admin/account/list', data);
};



/**
 * 账号新增
 */
export const createAccount = (data) => {
	return Axios.post('/gorc/admin/account/add', data);
};

